<template>
  <div class="home-slide-three">
    <!-- <div class="apply-btn" @click.stop="openLink()">免费申请</div> -->
    <img src="../assets/banner-btn2.png" alt="" class="apply-btn" @click.stop="openLink()"> 
  </div>
</template>
<script>
export default {
  data() {
    return {
      showBoxShadow: false
    }
  },
  methods: {
    openLink() {
      _czc.push(["_trackEvent", "肺炎_按钮1_立即申请", "button"]);
      this.$router.push('/apply')
    }
  }
}
</script>

<style lang="less">
.home-slide-three {
  width: 100%;
  height: 450px;
  background: url("../assets/home-banner-4.png") 50% 0 no-repeat;
  background-size: cover;
  background-color: #FFF;
  position: relative;
  .apply-btn {
    cursor: pointer;
    width: 160px;
    // height: 67px;
    position: absolute;
    left: 50%;
    margin-left: -590px;
    bottom: 63px;
    // margin-left: -80px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home-slide-three.vue